module.exports = __webpack_public_path__ + "img/desktop.98624eef.png";